import DownloadPage from './DownloadPage';

export default DownloadPage;
